import { useState, useEffect, useRef } from "react";
import { charCodeType } from "../../../../../common/CharCode.type";

type Props = {
  format: string;
  setFormat: (v: string) => void;
  setIsEncodingLocked: (v: boolean) => void;
  setCharCode: (v: charCodeType) => void;
  resetSignal: number;
};

const formatLabels: Record<string, string> = {
  "": "書式",
  standard: "標準",
  yealink: "YeaLink",
  cloudbiz: "CloudPhone Biz Pro",
};

const SelectFormat = ({
  format,
  setFormat,
  setIsEncodingLocked,
  setCharCode,
  resetSignal,
}: Props) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const [hasSelectedFormat, setHasSelectedFormat] = useState(false);

  const ENV = process.env.REACT_APP_ENV;
  const isCvd = ENV === "WIDETEC_CVD";

  useEffect(() => {
    setHasSelectedFormat(false);
    setOpen(false);
  }, [resetSignal]);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target as Node)
      ) {
        setOpen(false);
      }
    }
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const handleSelect = (type: string) => {
    setFormat(type);
    setHasSelectedFormat(true);

    if (type === "yealink" || type === "cloudbiz") {
      setIsEncodingLocked(true);
      setCharCode("utf8");
    } else {
      setIsEncodingLocked(false);
    }
    setOpen(false);
  };

  return (
    <div className="ms-2" ref={dropdownRef} style={{ position: "relative" }}>
      <button
        className="btn btn-light dropdown-toggle"
        onClick={() => setOpen(!open)}
      >
        {hasSelectedFormat ? formatLabels[format] || "書式" : "書式"}
      </button>

      {open && (
        <ul
          className="dropdown-menu show"
          style={{
            display: "block",
            position: "absolute",
            top: "100%",
            left: 0,
            zIndex: 999,
            minWidth: "100%",
          }}
        >
          <li>
            <button
              className="dropdown-item"
              onClick={() => handleSelect("standard")}
            >
              標準
            </button>
          </li>
          <li>
            <button
              className="dropdown-item"
              onClick={() => handleSelect("yealink")}
            >
              YeaLink
            </button>
          </li>

          {isCvd && (
            <li>
              <button
                className="dropdown-item"
                onClick={() => handleSelect("cloudbiz")}
              >
                CloudPhone Biz Pro
              </button>
            </li>
          )}
        </ul>
      )}
    </div>
  );
};

export default SelectFormat;
